/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';

interface ContasPagar {
  dataemissao: Date;
  datalan: Date;
  parceiro: string;
  historico: string;
  planoconta: string;
  fazenda: string;
  banco: string;
  numerodoc: string;
  valor: number;
}

async function RelatorioContasPagas(dados: ContasPagar[], periodo: string) {

  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  const TValor = dados.reduce((acc, item) => acc + item.valor, 0);

  const contapagar = dados.map((pagar) => {
    return [
      { text: moment(pagar.dataemissao).format('DD/MM/YYYY'), alignment: 'center', fontSize: 8 },
      { text: moment(pagar.datalan).format('DD/MM/YYYY'), alignment: 'center', fontSize: 8 },
      { text: pagar.numerodoc, alignment: 'left', fontSize: 7 },
      { text: pagar.parceiro, alignment: 'left', fontSize: 7 },
      { text: pagar.fazenda, alignment: 'left', fontSize: 7 },
      { text: pagar.historico, alignment: 'left', fontSize: 7 },
      { text: pagar.planoconta, alignment: 'left', fontSize: 7 },
      { text: pagar.banco, alignment: 'left', fontSize: 7 },
      { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(pagar.valor), alignment: 'right', fontSize: 8 },
    ];
  });

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () { 
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const imageUrl = process.env.REACT_APP_URL_IMGLOG || '';
  const imageData = await getBase64ImageFromUrl(imageUrl);

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }


  const documentDefinition: any = {
    pageSize: 'A4',
    pageMargins: [8, 8, 8, 8],
    pageOrientation: 'landscape',
    header: 'simple text',
    footer: {
      columns: [
        'Left part',
        { text: 'Right part', alignment: 'right' }
      ]
    },
    content: ([
      {
        table: {
          body: [
            [
              {
                image: imageData,
                width: 48,
                border: [false, false, false, false]
              },
              {
                border: [false, false, false, false],
                table: {
                  widths: [720],
                  body: [
                    [
                      { text: process.env.REACT_APP_URL_EMPRESA, fontSize: 16, margin: [0, 5, 0, 0], bold: true, color: process.env.COR_RELATORIOS_TEXTO, alignment: 'center', fillColor: process.env.COR_RELATORIOS, border: [false, false, false, false] },
                    ],
                    [
                      { text: process.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true] },
                    ],
                  ]
                }
              },

            ],
            [
              { text: 'Relatório de Contas Pagas', colSpan: 2, margin: [5, 10, 0, 0], fontSize: 18, bold: true, alignment: 'center', border: [false, false, false, false] },
              {}
            ]

          ]
        }
      },
      { text: periodo, fontSize: 8 },
      {
        table: {
          widths: [45, 48, 50, 150, 70, 150, 120, 40, 45],
          body: [
            [
              { text: 'Emissão', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Pagamento', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Documento', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Parceiro', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Fazenda', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Histórico', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Plano Conta', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Conta', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Valor', alignment: 'right', fillColor: '#dddddd', fontSize: 8 },

            ],
            ...contapagar,
            [
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: 'Totais', fontSize: 8, alignment: 'right', border: [false, false, false, false] },
              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TValor), alignment: 'right', fontSize: 7 },
            ]
          ]

        },
      },

    ]),

  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

  pdfDocGenerator.open();

}
export default RelatorioContasPagas;

